import { EMAIL_MSG } from "../../util"
import Email from "../../SendCoupon/Email"
import StandardOffersEmail from "../../SendCoupon/StandardOffersEmail"
import { couponPayload } from "../../../util"

const CouponEmailForms = ({
    storeId,
    store,
    coupon,
    coupons,
    handleApiCall,
    handleCloseEmail,
}) => {
    const formattedCoupons = coupon ? [couponPayload(coupon)] : undefined
    const couponsToDeliver = formattedCoupons ?? coupons

    return (
        <>
            {store && (
                <Email
                    {...{
                        store,
                        selectedCoupons: couponsToDeliver,
                        disclaimer: EMAIL_MSG,
                        handleApiCall,
                        handleCloseEmail,
                    }}
                />
            )}

            {!store && (
                <StandardOffersEmail
                    {...{
                        storeId,
                        offers: couponsToDeliver,
                        disclaimer: EMAIL_MSG,
                        handleApiCall,
                        handleCloseEmail,
                    }}
                />
            )}
        </>
    )
}

export default CouponEmailForms
